/* eslint-disable react/jsx-filename-extension */
import { Component } from 'react';
import './droparea_style.css';

const dragEvents = ['dragover', 'dragenter', 'dragleave', 'dragend', 'drop'];

/**
 *
 * @param {unknown} element
 * @returns {boolean}
 */
function isHTMLElement(element) {
  return element instanceof HTMLElement;
}

/**
 * @typedef {keyof typeof import('../../model/frontendmodel').MediaType} MediaType
 * @typedef {{ status: 'enter' | 'leave' }} State
 * @typedef {{
 *  target: string
 *  onDrop(files: File[], event: DragEvent): void
 *  filterFile(file: File): bool
 *  enabled: boolean
 * }} Props
 * @extends {Component<Props, State>}
 */
class DropArea extends Component {
  /**
   * @param {Readonly<Props>} props
   */
  constructor(props) {
    super(props);
    this.state = { status: 'leave' };
    this.el = document.querySelector(props.target);

    dragEvents.forEach(event => {
      this[`${event}Handler`] = this[`${event}Handler`].bind(this);
    });
  }

  componentDidMount() {
    dragEvents.forEach(event =>
      document.addEventListener(event, this[`${event}Handler`], false)
    );
  }

  componentWillUnmount() {
    dragEvents.forEach(event =>
      document.removeEventListener(event, this[`${event}Handler`], false)
    );
  }

  /**
   *
   * @param {React.DragEvent<HTMLDivElement>} event
   */
  dragoverHandler(event) {
    event.preventDefault();
  }

  /**
   *
   * @param {React.DragEvent<HTMLDivElement>} event
   */
  dragenterHandler(event) {
    const { enabled, target } = this.props;
    if (!enabled) return;
    if (isHTMLElement(event.target) && event.target.closest(target)) {
      this.setState({ status: 'enter' });
    }
  }

  /**
   *
   * @param {React.DragEvent<HTMLDivElement>} event
   */
  dragleaveHandler(event) {
    if (isHTMLElement(event.target) && event.target.matches('.droparea')) {
      this.setState({ status: 'leave' });
    }
  }

  /**
   *
   * @param {React.DragEvent<HTMLDivElement>} event
   */
  dragendHandler(event) {
    const { target } = this.props;
    if (isHTMLElement(event.target) && event.target.closest(target)) {
      this.setState({ status: 'leave' });
    }
  }

  /**
   *
   * @param {React.DragEvent<HTMLDivElement>} event
   */
  dropHandler(event) {
    event.preventDefault();
    const { enabled, filterFile, onDrop } = this.props;
    if (!enabled) return;

    const { dataTransfer } = event;
    if (dataTransfer.files instanceof FileList) {
      const files = Array.from(dataTransfer.files).filter(file =>
        filterFile(file)
      );
      onDrop(files, event);
    }
    this.setState({ status: 'leave' });
  }

  render() {
    const { status } = this.state;
    const { enabled } = this.props;

    if (enabled) {
      return (
        <div className="droparea" data-drag={status}>
          <div className="droparea__title">Drop files here</div>
          <div className="droparea__description">to send them</div>
        </div>
      );
    }
    return null;
  }
}

export default DropArea;
